import { apiClient } from '@/api/client';

/** Admin-managed Trusted Partner service category (FR-72). Mirrors `features/startups/api/taxonomy.api.ts`'s shape. */
export interface PartnerCategory {
  id: string;
  name: string;
  isRetired: boolean;
}

/** Live (non-retired) categories only - what a profile's category picker offers for a new selection. */
export async function fetchActivePartnerCategories(): Promise<PartnerCategory[]> {
  const { data } = await apiClient.get<PartnerCategory[]>('/taxonomy/partner-categories');
  return data;
}
